/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { httpClient } from "../../orval/http-client";
import type { ErrorType, BodyType } from "../../orval/http-client";
import { domainQueryKey } from "../../orval/query-key";
import type {
  AgentCreateResponse,
  AgentMarkSeenRequest,
  AgentResponse,
  AgentUpsertRequest,
  AgentsResponse,
  ErrorResponse,
} from "../model";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getSearchAgents = (
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<AgentsResponse>(
    { url: `/planning-proposal/agent`, method: "GET", signal },
    options,
  );
};

export const getGetSearchAgentsQueryKey = () =>
  domainQueryKey({}, { url: `/planning-proposal/agent` });

export const useGetSearchAgentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSearchAgents>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSearchAgents>>, TError, TData>
  >;
  request?: SecondParameter<typeof httpClient>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = domainQueryKey(
    {},
    { url: `/planning-proposal/agent`, queryOptions },
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchAgents>>> = ({
    signal,
  }) => getSearchAgents(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSearchAgents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSearchAgentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSearchAgents>>
>;
export type GetSearchAgentsQueryError = ErrorType<ErrorResponse>;

export function useGetSearchAgents<
  TData = Awaited<ReturnType<typeof getSearchAgents>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSearchAgents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchAgents>>,
          TError,
          Awaited<ReturnType<typeof getSearchAgents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSearchAgents<
  TData = Awaited<ReturnType<typeof getSearchAgents>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSearchAgents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchAgents>>,
          TError,
          Awaited<ReturnType<typeof getSearchAgents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSearchAgents<
  TData = Awaited<ReturnType<typeof getSearchAgents>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSearchAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSearchAgents<
  TData = Awaited<ReturnType<typeof getSearchAgents>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSearchAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetSearchAgentsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const createSearchAgent = (
  agentUpsertRequest: BodyType<AgentUpsertRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<AgentCreateResponse>(
    {
      url: `/planning-proposal/agent`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: agentUpsertRequest,
      signal,
    },
    options,
  );
};

export const getCreateSearchAgentMutationKey = () =>
  ["createSearchAgent"] as const;

export const getCreateSearchAgentMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSearchAgent>>,
    TError,
    CreateSearchAgentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSearchAgent>>,
  TError,
  CreateSearchAgentMutationVariables,
  TContext
> => {
  const mutationKey = getCreateSearchAgentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSearchAgent>>,
    CreateSearchAgentMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createSearchAgent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSearchAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSearchAgent>>
>;
export type CreateSearchAgentMutationBody = BodyType<AgentUpsertRequest>;
export type CreateSearchAgentMutationError = ErrorType<ErrorResponse>;
export type CreateSearchAgentMutationVariables = {
  data: BodyType<AgentUpsertRequest>;
};

export const useCreateSearchAgent = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSearchAgent>>,
      TError,
      CreateSearchAgentMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSearchAgent>>,
  TError,
  CreateSearchAgentMutationVariables,
  TContext
> => {
  return useMutation(getCreateSearchAgentMutationOptions(options), queryClient);
};
export const markSearchAgentProposalSeen = (
  agentId: string,
  agentMarkSeenRequest: BodyType<AgentMarkSeenRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<void>(
    {
      url: `/planning-proposal/agent/${agentId}/seen`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: agentMarkSeenRequest,
      signal,
    },
    options,
  );
};

export const getMarkSearchAgentProposalSeenMutationKey = () =>
  ["markSearchAgentProposalSeen"] as const;

export const getMarkSearchAgentProposalSeenMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markSearchAgentProposalSeen>>,
    TError,
    MarkSearchAgentProposalSeenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markSearchAgentProposalSeen>>,
  TError,
  MarkSearchAgentProposalSeenMutationVariables,
  TContext
> => {
  const mutationKey = getMarkSearchAgentProposalSeenMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markSearchAgentProposalSeen>>,
    MarkSearchAgentProposalSeenMutationVariables
  > = (props) => {
    const { agentId, data } = props ?? {};

    return markSearchAgentProposalSeen(agentId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkSearchAgentProposalSeenMutationResult = NonNullable<
  Awaited<ReturnType<typeof markSearchAgentProposalSeen>>
>;
export type MarkSearchAgentProposalSeenMutationBody =
  BodyType<AgentMarkSeenRequest>;
export type MarkSearchAgentProposalSeenMutationError = ErrorType<ErrorResponse>;
export type MarkSearchAgentProposalSeenMutationVariables = {
  agentId: string;
  data: BodyType<AgentMarkSeenRequest>;
};

export const useMarkSearchAgentProposalSeen = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markSearchAgentProposalSeen>>,
      TError,
      MarkSearchAgentProposalSeenMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markSearchAgentProposalSeen>>,
  TError,
  MarkSearchAgentProposalSeenMutationVariables,
  TContext
> => {
  return useMutation(
    getMarkSearchAgentProposalSeenMutationOptions(options),
    queryClient,
  );
};
export const markAllSearchAgentProposalsSeen = (
  agentId: string,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<void>(
    {
      url: `/planning-proposal/agent/${agentId}/seen/all`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getMarkAllSearchAgentProposalsSeenMutationKey = () =>
  ["markAllSearchAgentProposalsSeen"] as const;

export const getMarkAllSearchAgentProposalsSeenMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllSearchAgentProposalsSeen>>,
    TError,
    MarkAllSearchAgentProposalsSeenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAllSearchAgentProposalsSeen>>,
  TError,
  MarkAllSearchAgentProposalsSeenMutationVariables,
  TContext
> => {
  const mutationKey = getMarkAllSearchAgentProposalsSeenMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markAllSearchAgentProposalsSeen>>,
    MarkAllSearchAgentProposalsSeenMutationVariables
  > = (props) => {
    const { agentId } = props ?? {};

    return markAllSearchAgentProposalsSeen(agentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAllSearchAgentProposalsSeenMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAllSearchAgentProposalsSeen>>
>;

export type MarkAllSearchAgentProposalsSeenMutationError =
  ErrorType<ErrorResponse>;
export type MarkAllSearchAgentProposalsSeenMutationVariables = {
  agentId: string;
};

export const useMarkAllSearchAgentProposalsSeen = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markAllSearchAgentProposalsSeen>>,
      TError,
      MarkAllSearchAgentProposalsSeenMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof markAllSearchAgentProposalsSeen>>,
  TError,
  MarkAllSearchAgentProposalsSeenMutationVariables,
  TContext
> => {
  return useMutation(
    getMarkAllSearchAgentProposalsSeenMutationOptions(options),
    queryClient,
  );
};
export const getSearchAgent = (
  agentId: string,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<AgentResponse>(
    { url: `/planning-proposal/agent/${agentId}`, method: "GET", signal },
    options,
  );
};

export const getGetSearchAgentQueryKey = (agentId: string) =>
  domainQueryKey({ agentId }, { url: `/planning-proposal/agent/${agentId}` });

export const useGetSearchAgentQueryOptions = <
  TData = Awaited<ReturnType<typeof getSearchAgent>>,
  TError = ErrorType<ErrorResponse>,
>(
  agentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSearchAgent>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpClient>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = domainQueryKey(
    { agentId },
    { url: `/planning-proposal/agent/${agentId}`, queryOptions },
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchAgent>>> = ({
    signal,
  }) => getSearchAgent(agentId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: agentId !== null && agentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSearchAgent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSearchAgentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSearchAgent>>
>;
export type GetSearchAgentQueryError = ErrorType<ErrorResponse>;

export function useGetSearchAgent<
  TData = Awaited<ReturnType<typeof getSearchAgent>>,
  TError = ErrorType<ErrorResponse>,
>(
  agentId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSearchAgent>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchAgent>>,
          TError,
          Awaited<ReturnType<typeof getSearchAgent>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSearchAgent<
  TData = Awaited<ReturnType<typeof getSearchAgent>>,
  TError = ErrorType<ErrorResponse>,
>(
  agentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSearchAgent>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchAgent>>,
          TError,
          Awaited<ReturnType<typeof getSearchAgent>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSearchAgent<
  TData = Awaited<ReturnType<typeof getSearchAgent>>,
  TError = ErrorType<ErrorResponse>,
>(
  agentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSearchAgent>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetSearchAgent<
  TData = Awaited<ReturnType<typeof getSearchAgent>>,
  TError = ErrorType<ErrorResponse>,
>(
  agentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSearchAgent>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useGetSearchAgentQueryOptions(agentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const deleteSearchAgent = (
  agentId: string,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<void>(
    { url: `/planning-proposal/agent/${agentId}`, method: "DELETE", signal },
    options,
  );
};

export const getDeleteSearchAgentMutationKey = () =>
  ["deleteSearchAgent"] as const;

export const getDeleteSearchAgentMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSearchAgent>>,
    TError,
    DeleteSearchAgentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSearchAgent>>,
  TError,
  DeleteSearchAgentMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteSearchAgentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSearchAgent>>,
    DeleteSearchAgentMutationVariables
  > = (props) => {
    const { agentId } = props ?? {};

    return deleteSearchAgent(agentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSearchAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSearchAgent>>
>;

export type DeleteSearchAgentMutationError = ErrorType<ErrorResponse>;
export type DeleteSearchAgentMutationVariables = { agentId: string };

export const useDeleteSearchAgent = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSearchAgent>>,
      TError,
      DeleteSearchAgentMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSearchAgent>>,
  TError,
  DeleteSearchAgentMutationVariables,
  TContext
> => {
  return useMutation(getDeleteSearchAgentMutationOptions(options), queryClient);
};
export const updateSearchAgent = (
  agentId: string,
  agentUpsertRequest: BodyType<AgentUpsertRequest>,
  options?: SecondParameter<typeof httpClient>,
  signal?: AbortSignal,
) => {
  return httpClient<void>(
    {
      url: `/planning-proposal/agent/${agentId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: agentUpsertRequest,
      signal,
    },
    options,
  );
};

export const getUpdateSearchAgentMutationKey = () =>
  ["updateSearchAgent"] as const;

export const getUpdateSearchAgentMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSearchAgent>>,
    TError,
    UpdateSearchAgentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSearchAgent>>,
  TError,
  UpdateSearchAgentMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateSearchAgentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSearchAgent>>,
    UpdateSearchAgentMutationVariables
  > = (props) => {
    const { agentId, data } = props ?? {};

    return updateSearchAgent(agentId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSearchAgentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSearchAgent>>
>;
export type UpdateSearchAgentMutationBody = BodyType<AgentUpsertRequest>;
export type UpdateSearchAgentMutationError = ErrorType<ErrorResponse>;
export type UpdateSearchAgentMutationVariables = {
  agentId: string;
  data: BodyType<AgentUpsertRequest>;
};

export const useUpdateSearchAgent = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSearchAgent>>,
      TError,
      UpdateSearchAgentMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpClient>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateSearchAgent>>,
  TError,
  UpdateSearchAgentMutationVariables,
  TContext
> => {
  return useMutation(getUpdateSearchAgentMutationOptions(options), queryClient);
};
